import React from 'react';

import { createMuiTheme, ThemeProvider, makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button'


const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#29479a'
        },
    },
    typography: {
        fontFamily: 'Nunito',
    },
    overrides: {
        MuiStepIcon: {
            root: {
                color: "#414042",
            },
            active: {
                color: '#fff'
            },
            text: {
                fill: '#fff',
            }
        },
        MuiStepLabel: { 
            label: {
                color: '#414042',
                fontSize: 'large',
            },
            active: {
                color: '#29479a',
                fontSize: 'xx-large',
            },
            completed: {
                color: '#29479a',
                fontSize: 'large',
            },
        },
    }
})

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
    return ['Scope', 'Match', 'Build'];
}

export default function HorizontalLinearStepper(props) {
  const classes = useStyles();
  const steps = getSteps();

  return (
    <div className={classes.root}>
    <ThemeProvider theme={theme}>
      <Stepper activeStep={props.stage}>
        {steps.map((label, index) => {
          return (
            <Step key={label} >
              <StepLabel >{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Button
        disabled={props.stage === 0}
        onClick={props.back}
      >
        Back
      </Button>
    </ThemeProvider>
    </div>
  );
}
